import React from 'react';
import {skipThisGwType} from '../utilsFui'
import {cl, globs} from '../../components/utils/utils';

class TextDisplay extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.props.getValue(props.ind, {type: "local"})
  }

  render(){
    if(skipThisGwType(this.props)){return null}
    let text=this.props.custom.text
    if((this.props.type||"").startsWith("zone_History")){
      text=text.replace(/iGrow 1800/g, "controller")
    }
    return(
      <div dangerouslySetInnerHTML={{__html: text}}></div>
    );
  }
}

  export default TextDisplay ;
